import Skeleton from 'antd/lib/skeleton'
import { useEffect, useState } from 'react'
import { getFileDownloadUrl } from 'Services/tasks.service'

export const S3Link = ({ url }: { url: string }) => {
    const [downloadUrl, setDownloadUrl] = useState<string | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchDownloadUrl = async () => {
            try {
                setIsLoading(true)
                setError(null)
                const downloadUrl = await getFileDownloadUrl(url)
                setDownloadUrl(downloadUrl)
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to load download URL')
            } finally {
                setIsLoading(false)
            }
        }

        fetchDownloadUrl()
    }, [url])

    if (isLoading) {
        return <Skeleton active />
    }

    if (error) {
        return (
            <div className="label-value" style={{ color: 'red' }}>
                Error: {error}
            </div>
        )
    }

    return (
        <a href={downloadUrl ?? ''} target="_blank" rel="noopener noreferrer">
            Download File
        </a>
    )
}
